/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/MassageGun/gunTopCover.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation10.play();
    actions.Animation10.repetitions = 1;
    actions.Animation10.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="topCover" geometry={nodes.topCover.geometry} material={materials['材質.003']} />
      </group>
    </group>
  )
}

useGLTF.preload('/MassageGun/gunTopCover.glb')
